import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = { variantSku: String }
  static targets = [
    'productName',
    'brandName',
    'variantSku',
  ]

  productChanged(e) {
    this.productNameTarget.textContent = e.target.value
  }

  brandChanged(e) {
    const selectedText = e.target.options[e.target.selectedIndex].text
    this.brandNameTarget.textContent = selectedText
  }

  variantChanged(e) {
    if (e.target.dataset.checked === "true") {
      e.target.checked = false
      e.target.dataset.checked = "false"
      this.variantSkuTarget.textContent = this.variantSkuValue
    } else {
      this.element.querySelectorAll(`input[name="${e.target.name}"]`).forEach(radio => {
        radio.dataset.checked = "false"
      })
      e.target.dataset.checked = "true"
      const label = this.element.querySelector(`label[for="${ e.target.id}"]`)
      if (label) {
        const selectedText = label.textContent.trim()
        let sku = selectedText.split(' - ').pop().replace(/[()]/g, '').trim()
        this.variantSkuTarget.textContent = sku
      } else {
        this.variantSkuTarget.textContent = this.variantSkuValue
      }
    }
  }
}
